import React, { useEffect, useState } from 'react';
import { MARKS } from '../../../constants/columns';
import { useTable, useGlobalFilter, usePagination, useSortBy } from 'react-table';
import { carsOptions } from '../../../constants/filterOptions';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import getMarks from '../../../api/cars/getMarks';
import deleteMark from '../../../api/cars/deleteMark';

// components
import Header from '../../../components/Header/Header';
import Table from '../../../components/Table/Table';
import TableTabs from '../../../components/TableTabs/TableTabs';
import Empty from '../../../components/Empty/Empty';
import ConfirmModal from '../../../components/Modal/ConfirmModal';

import alert from '../../../helpers/alert';
import extractErrorMessage from '../../../utils/extractErrorMessage';
import { ROLE_ADMIN } from '../../../constants/roles';

// icons
import icon from '../../../brand/generated/sidebar/cars.svg';
import notFound from '../../../brand/generated/notFound.svg';
import bucketIcon from '../../../brand/generated/popover/delete.svg';

const columns = MARKS;

const CarMarks = () => {
  const navigate = useNavigate();
  const roleId = useSelector((state) => state?.user?.roleId);
  const [loading, setLoading] = useState(true);
  const [marks, setMarks] = useState([]);
  const [pagination, setPagination] = useState({
    page: 1,
    totalPages: 1,
    hasPreviousPage: false,
    hasNextPage: false,
    pageSize: 10,
  });

  const table = useTable(
    {
      columns,
      data: marks,
      disableSortRemove: true,
      initialState: {
        pageSize: pagination.pageSize,
      },
      manualPagination: true,
      pageCount: pagination.totalPages,
      page: pagination.page - 1,
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );
  const { setGlobalFilter, page } = table;

  const [value, setValue] = useState('');

  const [deleteRow, setDeleteRow] = useState(null);
  const [saving, setSaving] = useState(false);

  const handleNavigate = () => {
    navigate('/cars/marks/create');
  };

  // Ð¡ÑÑÐ°Ð½Ð¸ÑÑ Ð¾Ð±ÑÐ·Ð°ÑÐµÐ»ÑÐ½Ð¾ Ð¿ÐµÑÐµÐ´Ð°ÑÐ¼ Ð² Ð·Ð°Ð¿ÑÐ¾Ñ: ÑÐ¿Ð¸ÑÐ¾Ðº ÑÐµÑÐ²ÐµÑÐ½ÑÐ¹ (manualPagination),
  // Ð¸ Ð±ÐµÐ· ÑÑÐ¾Ð³Ð¾ Â«ÐÐ¿ÐµÑÑÐ´Â» ÑÐ¾Ð»ÑÐºÐ¾ Ð¼ÐµÐ½ÑÐ»Ð¾ Ð¿Ð¾Ð´ÑÐ²ÐµÑÐºÑ Ð½Ð¾Ð¼ÐµÑÐ°, Ð° Ð´Ð°Ð½Ð½ÑÐµ Ð¾ÑÑÐ°Ð²Ð°Ð»Ð¸ÑÑ Ñ
  // Ð¿ÐµÑÐ²Ð¾Ð¹ ÑÑÑÐ°Ð½Ð¸ÑÑ.
  const init = (page = 1) => {
    setLoading(true);
    getMarks({ page })
      .then((res) => {
        setMarks(res.data.marks);
        setPagination({
          ...res.data.pagination,
          page: res.data.pagination?.pageNumber,
          pageSize: pagination.pageSize,
        });
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    init(pagination.page);
  }, [pagination.page]);

  // ÐÑÐºÐ°Ð·Ñ Ð±ÑÐºÐ° Ð¾ÑÐ¼ÑÑÐ»ÐµÐ½Ð½ÑÐµ (Â«Ñ Ð¼Ð°ÑÐºÐ¸ ÐµÑÑÑ Ð¼Ð¾Ð´ÐµÐ»Ð¸Â», Â«Ð¿ÑÐ¸Ð²ÑÐ·Ð°Ð½Ñ ÐÐ¦Â»), Ð¿Ð¾ÑÑÐ¾Ð¼Ñ
  // Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÐµÐ¼ Ð¸Ñ ÐºÐ°Ðº ÐµÑÑÑ â Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑÑ Ð¿Ð¾Ð½ÑÑÐ½Ð¾, ÑÑÐ¾ ÑÐ±ÑÐ°ÑÑ ÑÐ½Ð°ÑÐ°Ð»Ð°.
  const run = async (action, successText) => {
    setSaving(true);
    try {
      await action();
      alert.success(successText);
      setDeleteRow(null);
      init(pagination.page);
    } catch (e) {
      alert.error(extractErrorMessage(e?.response?.data) || e?.message || 'ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ Ð²ÑÐ¿Ð¾Ð»Ð½Ð¸ÑÑ Ð´ÐµÐ¹ÑÑÐ²Ð¸Ðµ');
    } finally {
      setSaving(false);
    }
  };

  // Ð£Ð´Ð°Ð»ÐµÐ½Ð¸Ðµ ÑÐ¿ÑÐ°Ð²Ð¾ÑÐ½Ð¸ÐºÐ° â ÑÐ¾Ð»ÑÐºÐ¾ Ð°Ð´Ð¼Ð¸Ð½Ð¸ÑÑÑÐ°ÑÐ¾ÑÑ; Ð±ÑÐº Ð¿ÑÐ¾Ð²ÐµÑÑÐµÑ ÑÑÐ¾ Ð¶Ðµ ÑÐ°Ð¼,
  // Ð·Ð´ÐµÑÑ Ð¿ÑÐ¾ÑÑÐ¾ Ð½Ðµ Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÐµÐ¼ Ð½ÐµÐ´Ð¾ÑÑÑÐ¿Ð½Ð¾Ðµ Ð´ÐµÐ¹ÑÑÐ²Ð¸Ðµ.
  const popover =
    roleId === ROLE_ADMIN
      ? [{ title: 'Ð£Ð´Ð°Ð»Ð¸ÑÑ', icon: bucketIcon, onClick: (row) => setDeleteRow(row) }]
      : undefined;

  return (
    <>
      <Header title="ÐÐ°ÑÐºÐ¸" icon={icon} />
      <TableTabs
        setFilter={setGlobalFilter}
        options={carsOptions}
        value={value}
        setValue={setValue}
        navigate={handleNavigate}
        button={'ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ Ð¼Ð°ÑÐºÑ'}
        inputPlaceholder={'ÐÑÑÑÑÑÐ¹ Ð¿Ð¾Ð¸ÑÐº Ð¿Ð¾ Ð¼Ð°ÑÐºÐ°Ð¼'}
      />
      <br />
      {!page.length && !loading ? (
        <Empty />
      ) : (
        <Table
          table={table}
          all={'Ð¼Ð°ÑÐ¾Ðº'}
          loading={loading}
          pagination
          setPagination={setPagination}
          p={pagination}
          popover={popover}
        />
      )}

      <ConfirmModal
        isOpen={Boolean(deleteRow)}
        onClose={() => setDeleteRow(null)}
        title="Ð£Ð´Ð°Ð»Ð¸ÑÑ Ð¼Ð°ÑÐºÑ"
        text={`Ð£Ð´Ð°Ð»Ð¸ÑÑ Ð¼Ð°ÑÐºÑ Â«${deleteRow?.name || ''}Â»? ÐÐµÐ¹ÑÑÐ²Ð¸Ðµ Ð½ÐµÐ¾Ð±ÑÐ°ÑÐ¸Ð¼Ð¾.`}
        loading={saving}
        onConfirm={() => run(() => deleteMark({ id: deleteRow.id }), 'ÐÐ°ÑÐºÐ° ÑÐ´Ð°Ð»ÐµÐ½Ð°')}
      />
    </>
  );
};

export default CarMarks;
